import { PublicClientApplication } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID;
const redirectUri = process.env.REACT_APP_REDIRECT_URI;

if (!clientId) {
  throw new Error("Missing required environment variable: REACT_APP_CLIENT_ID");
}
if (!tenantId) {
  throw new Error("Missing required environment variable: REACT_APP_TENANT_ID");
}
if (!redirectUri) {
  throw new Error("Missing required environment variable: REACT_APP_REDIRECT_URI");
}

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
});
